/**
 * Created by abbeymart on 2016-12-21.
 * Localization/Internationalization: languages, labels, contents/pages, messages etc.
 */

import type { RouteRecordRaw } from 'vue-router';

export const contentRoutes: Array<RouteRecordRaw> = [
  {
    path: '/content',
    name: 'content',
    redirect: '/content/list',
    component: () => import('pages/central/content/McContent.vue'),
    meta: {
      title: 'Contents',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'contentList',
        component: () => import('pages/central/content/ContentList.vue'),
        meta: {
          title: 'Contents List',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'contentExplorer',
        component: () => import('pages/central/content/ContentExplorer.vue'),
        meta: {
          title: 'Contents Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'contentDetail',
        component: () => import('pages/central/content/ContentDetail.vue'),
        meta: {
          title: 'Content Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'contentNew',
        component: () => import('pages/central/content/ContentNew.vue'),
        meta: {
          title: 'New Content',
          requiresAuth: true,
        },
      },
    ],
  },
];
